module.exports = __webpack_public_path__ + "img/lowwaterpressure.175e96f9.svg";